import React, { useEffect } from 'react';
import {
    changeDepartment1All,
    changeDepartment2All,
    changeAddressAll,
    changeSuiteRoomAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changePhoneAll,
    changeFaxAll,
    changeEmailAll,
    changeWebsiteAll,
    getAddressLine1P2T3,
    getAddressLine2P2T3,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP2T3 = React.memo((props) => {
    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeWebsiteAll(props.website);
    }, [props.website]);

    const handleSetAddress = (value) => {
        changeAddressAll(value);
        const address = getAddressLine1P2T3();

        if (address.length > 60) {
            props.setAddress(props.address);
            changeAddressAll(props.address);
        } else {
            props.setAddress(value);
        }
    };

    const handleSetSuiteRoom = (value) => {
        changeSuiteRoomAll(value);
        const address = getAddressLine1P2T3();

        if (address.length > 60) {
            props.setSuiteRoom(props.suiteRoom);
            changeSuiteRoomAll(props.suiteRoom);
        } else {
            props.setSuiteRoom(value);
        }
    };

    const handleSetCity = (value) => {
        changeCityAll(value);
        const address = getAddressLine2P2T3();

        if (address.length > 60) {
            props.setCity(props.city);
            changeCityAll(props.city);
        } else {
            props.setCity(value);
        }
    };

    const handleSetZip = (value) => {
        changeZipAll(value);
        const address = getAddressLine2P2T3();

        if (address.length > 60) {
            props.setZip(props.zip);
            changeZipAll(props.zip);
        } else {
            props.setZip(value);
        }
    };

    const renderCount = (value, limit) => {
        let count = 0;
        if (value) {
            count = value.length;
        }

        return <div className="limit-message">{count}/{limit} characters</div>;
    };

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Clinic/Department 1"
                limit="55"
                showCount
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic or Department Line 1"
            />
            <TextField
                label="Clinic/Department 2"
                limit="55"
                showCount
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic or Department Line 2"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={handleSetAddress}
                placeholder="Address"
            />
            <TextField
                label="Suite #"
                value={props.suiteRoom}
                setFunction={handleSetSuiteRoom}
                placeholder="Suite/Building #"
            />
            {renderCount(getAddressLine1P2T3(), 60)}
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={handleSetCity}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={handleSetZip}
            />
            {renderCount(getAddressLine2P2T3(), 60)}
            <hr />
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                limit="12"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                limit="12"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <TextField
                label="Email Address (optional)"
                limit="60"
                showCount
                value={props.email}
                setFunction={props.setEmail}
                placeholder="Email Address (optional)"
            />
            <TextField
                isWebsite
                label="Web address (optional)"
                limit="60"
                showCount
                value={props.website}
                setFunction={props.setWebsite}
                placeholder="UTPhysicians.com"
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                    { value: '2000', label: '2000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded Custom Letterhead</div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>Variable on front</li>
                        <li>8.5x11"</li>
                        <li>One-sided</li>
                        <li>Color</li>
                        <li>80# Avalanche Smooth Text</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP2T3;
